<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousFFView"
              >&laquo; Back</md-button
            >
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2 style="text-align: center">Assignment Tracking</h2>
          </md-layout>
        </md-layout>
        <hr class="hr-s" />

        <div class="row">
          <div class="col-md-9">
            <!-- DIRECT CHAT -->
            <div class="box box-warning direct-chat direct-chat-warning">
              <div class="box-header with-border">
                <h3 class="box-title">Tracking Status</h3>

                <!-- <div class="box-tools pull-right">
                  <span
                    data-toggle="tooltip"
                    title
                    class="badge bg-yellow"
                    data-original-title="3 New Messages"
                  >{{clientChat.length}} Messages</span>
                </div>-->
              </div>
              <!-- /.box-header  style="border:1px solid #e7e7e7" -->
              <div class="box-body" style="border: none">
                <!-- Conversations are loaded here -->
                <div
                  class="direct-chat-messages"
                  style="height: 350px"
                  id="your_div"
                >
                  <!-- {{clientChat.length}} -->
                  <ul
                    style="padding: 0; margin: 0"
                    v-for="(item, index) in clientChat"
                    :key="index"
                    :id="'check' + index"
                  >
                    <div
                      class="direct-chat-msg"
                      v-bind:class="item.clientId != '0' ? 'right' : ''"
                    >
                      <div class="direct-chat-info clearfix">
                        <span
                          class="direct-chat-name"
                          v-bind:class="
                            item.clientId != '0' ? 'pull-right' : 'pull-left'
                          "
                          >{{
                            item.clientId == "0" ? "Pridel Team" : "You"
                          }}</span
                        >
                        <span
                          class="direct-chat-timestamp"
                          v-bind:class="
                            item.clientId != '0' ? 'pull-left' : 'pull-right'
                          "
                          >{{ item.loginTime | moment }}</span
                        >
                      </div>
                      <!-- /.direct-chat-info -->
                      <img
                        class="direct-chat-img"
                        src="https://image.flaticon.com/icons/svg/149/149452.svg"
                        alt="message user image"
                      />
                      <!-- /.direct-chat-img -->
                      <div class="direct-chat-text">{{ item.remarkMsg }}</div>
                      <!-- /.direct-chat-text -->
                    </div>
                  </ul>
                  <!-- /.direct-chat-msg -->
                </div>
                <!--/.direct-chat-messages-->

                <!-- /.direct-chat-pane -->
              </div>
              <!-- /.box-body -->
              <!-- /.box-footer-->
            </div>
            <!--/.direct-chat -->
          </div>
        </div>
        <hr class="hr-s" />

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="75">
            <md-layout md-flex="100">
              <label for="itemDescription">Message</label>

              <b-form-textarea
                :formatter="capitalizeAll"
                id="remark"
                name="remark"
                v-model="updateModal.remarkMsg"
                style="height: 50px"
              ></b-form-textarea>
              <span class="error" v-if="!updateModal.remarkMsg">{{
                errorDocModal.remarkMsg
              }}</span>
            </md-layout>
          </md-layout>

          <md-layout md-flex="15">
            <md-button
              style="margin-top: 25px"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              id="addButtonLoader1"
              @click="sendUpdate"
              >Send</md-button
            >
            <md-spinner
              md-indeterminate
              id="loader1"
              style="display: none"
            ></md-spinner>
          </md-layout>
        </md-layout>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Client") &&
      JSON.parse(this.$sessionsStorage.get("MessageStatus")) != "" &&
      JSON.parse(this.$sessionsStorage.get("MessageStatus")) != null
    ) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCImportDetails");

      this.getData("2");
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      updateModal: {
        remarkMsg: "",

        msgType: "",
        status: "",
      },

      statusList: [
        {
          statusV: "1",
          statusT: "In-Progress",
        },
        {
          statusV: "2",
          statusT: "Completed",
        },
        {
          statusV: "3",
          statusT: "Pending Due to Errors",
        },
      ],
      clientChat: [],
      internalChat: [],
      typeList: [
        {
          typeV: "1",
          typeT: "Client",
        },
        {
          typeV: "2",
          typeT: "Internal",
        },
      ],
      errorDocModal: {
        remarkMsg: "",
      },
      validate: true,
      errorDo: ["Enter Msg"],
      isLoading: false,
      designation: "",
      departmentName: "",
      MessageStatus: JSON.parse(this.$sessionsStorage.get("MessageStatus")),
      AirImportData: [],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return moment(date).format(" Do MMM 'YY  H:m");
    },
  },

  beforeDestroy() {
    // this.$sessionsStorage.set("MessageStatus", "");
  },

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    ModelListSelect,
  },

  computed: {},

  methods: {
    validateSend() {
      let validate_new = true;

      Object.keys(this.errorDocModal).map((x, index) => {
        if (this.updateModal[x] == "") {
          this.errorDocModal[x] = this.errorDo[index];

          validate_new = false;
        } else {
          this.errorDocModal[x] = "";
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    sendUpdate() {
      this.validateSend();

      Object.keys(this.MessageStatus).map((x) => {
        this.updateModal[x] = this.MessageStatus[x];
      });

      if (this.validate != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/addMessageInternal.php`,
          data: JSON.stringify(this.updateModal),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");

              Object.keys(this.updateModal).map((x) => {
                this.updateModal[x] = "";
              });

              this.getData("1");
            }
          })
          .catch((error) => {});
      }
    },
    previousFFView() {
      if (this.MessageStatus.typeOf == "1") {
        this.$router.push({
          path: "/CCImport/clientCcImport",
        });
      } else if (this.MessageStatus.typeOf == "2") {
        this.$router.push({
          path: "/CCImport/clientCcExport",
        });
      } else if (this.MessageStatus.typeOf == "3") {
        this.$router.push({
          path: "/Air/clientAirImport",
        });
      } else if (this.MessageStatus.typeOf == "4") {
        this.$router.push({
          path: "/AirImport/clientAirExport",
        });
      } else if (this.MessageStatus.typeOf == "5") {
        this.$router.push({
          path: "/SeaImp/clientSeaImpNormal",
        });
      } else if (this.MessageStatus.typeOf == "6") {
        this.$router.push({
          path: "/SeaImp/clientSeaImpConso",
        });
      } else if (this.MessageStatus.typeOf == "7") {
        this.$router.push({
          path: "/SeaExp/clientSeaExpNormal",
        });
      } else if (this.MessageStatus.typeOf == "8") {
        this.$router.push({
          path: "/SeaExp/clientSeaExpConso",
        });
      }
    },
    goToMain() {
      this.$sessionsStorage.set("editCcImportId", "");
      this.$router.push({
        path: "/ccImport/CCImportEntry",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    getData(id) {
      if (id == "2") {
        this.isLoading = true;
      }
      let payload = JSON.parse(this.$sessionsStorage.get("MessageStatus"));

      let options = {
        method: "POST",
        url: `${URL_BASE}/getMessageList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.messageList.length > 0) {
              let array1 = data.messageList.filter((x) => {
                return x.msgType == "1";
              });
              if (array1.length > 0) {
                this.clientChat = array1;
              }
            }

            // if (data.messageList.length > 0) {
            //   this.AirImportData = data.messageList;
            // }

            // setInterval(() => {
            //   this.getData();
            // }, 10000);

            // objDiv.scrollBy(100, 100);
            //  alert($("#your_div").get(0).scrollHeight);
            $("#your_div").animate(
              {
                scrollTop: $("#your_div").get(0).scrollHeight + 10000,
              },
              1000
            );
            if (id == "2") {
              this.isLoading = false;
            }
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// clientChatScreen.vue?302a0df4